import type { ReactNode } from 'react';

import { cn } from '../utils/cn';

/** Shared CTA classes for optional ErrorState actions (link or button). */
export const errorStateActionClassName =
  'bg-accent text-accent-fg mt-8 inline-flex rounded-xl px-6 py-3 text-sm font-semibold';

/**
 * Full-page terminal error / block chrome: danger mark, title, body, optional
 * action. Omit `action` when there is nothing the user can do.
 */
export function ErrorState({
  title,
  message,
  action,
  className,
}: {
  title: string;
  message: string;
  action?: ReactNode;
  className?: string;
}) {
  return (
    <main
      className={cn(
        'mx-auto flex min-h-dvh w-full max-w-md flex-col items-center justify-center px-6 text-center',
        className,
      )}
    >
      <div className="bg-danger/10 text-danger mb-6 flex h-16 w-16 items-center justify-center rounded-full text-3xl">
        !
      </div>
      <h1 className="text-2xl font-semibold tracking-tight">{title}</h1>
      <p className="text-fg-muted mt-2 text-sm">{message}</p>
      {action}
    </main>
  );
}
